module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-700italic.woff2?2a0783bd1c6c1469558bfa573cfa0c0c";